import PerfilUsuarioAtendimento from "../enum/perfilUsuarioAtendimento";

export default class ConfiguracaoUsuarioAtendimentoModel {
    usuarioId?: number = null;
    usuarioDescricao?: string = null;
    perfilUsuarioAtendimento: PerfilUsuarioAtendimento;
    perfilUsuarioAtendimentoDescricao: string;
    ativoAlocacaoAutomatica: boolean;
}
